import { render, staticRenderFns } from "./purchases-container.vue?vue&type=template&id=09c54426&scoped=true&lang=pug"
import script from "./purchases-container.js?vue&type=script&lang=js&external"
export * from "./purchases-container.js?vue&type=script&lang=js&external"
import style0 from "./purchases-container.vue?vue&type=style&index=0&id=09c54426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c54426",
  null
  
)

export default component.exports